import { useState } from 'react'

import { type EmailTemplate, type EmailTemplateOwner, useOthersEmailTemplates } from '@/models/emailTemplate'
import { TeammateSelect } from './TeammateSelect'
import { TemplatesPane } from './TemplatesPane'

// The API orders these by owner name, so first-seen order is alphabetical.
function ownersOf(templates: EmailTemplate[]): EmailTemplateOwner[] {
  const owners = new Map<string, EmailTemplateOwner>()
  for (const template of templates) {
    if (!owners.has(template.owner.id)) owners.set(template.owner.id, template.owner)
  }
  return [...owners.values()]
}

export function OthersTab() {
  const { data: templates = [], isLoading } = useOthersEmailTemplates()
  const [pickedOwnerId, setPickedOwnerId] = useState<string | null>(null)

  const owners = ownersOf(templates)
  const ownerId = owners.find((o) => o.id === pickedOwnerId)?.id ?? owners.at(0)?.id ?? null

  return (
    <TemplatesPane
      templates={templates.filter((t) => t.owner.id === ownerId)}
      isLoading={isLoading}
      canManage={false}
      emptyText="No one else has templates yet."
      toolbar={
        owners.length > 0 && ownerId !== null ? (
          <TeammateSelect owners={owners} value={ownerId} onValueChange={setPickedOwnerId} />
        ) : null
      }
    />
  )
}
